/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
/* eslint-disable no-use-before-define */

import "phaser";
import { Player } from "../Entities/Player"
import { Shield } from "../Entities/Shields"
import { EnemyLaser } from "../Entities/Enemies"
import { Shoot } from "../Entities/Shoots"
import { SelfDestruction, Bar } from "../Entities/GlobalEntities"
import { SceneGlobales } from "../ScenesHelpers/SceneGlobales"
import { firetail } from "../firetail";
import { FuelBar } from "./../FuelBar";
import { getRandomInt, AddImageToScene, loadImage, loadSpritesheet, loadAudio } from "../modules/utiltes"
import { EnemyHandler } from "../ScenesHelpers/EnemyHandler";
/////////////////////////////////

export class loadingscene extends Phaser.Scene {
        constructor() {
            super({
                key: "loadingscene",
            });
            this.sceneGlobales = new SceneGlobales()

        }

        init(data) {
            // Access the mode parameter passed from Scene 1
            this.mode = data.mode;
        }
        preload() {

                if (!this.textures.exists('deepspace')) {
                    this.bg = AddImageToScene(this, "loadingscene")
                        ////////////////////////////////////////////////////
                    let progressBar = this.add.graphics({
                        x: -280,
                        add: true,
                    });
                    let progressBox = this.add.graphics({
                        x: -280,
                        add: true,
                    });
                    progressBox.fillStyle(0x222222, 0.8);
                    progressBox.fillRect(370, 320, 320, 50);
                    let width = this.cameras.main.width;
                    let height = this.cameras.main.height;
                    let loadingText = this.make.text({
                        x: width / 2,
                        y: height / 2 - 50,
                        text: "Loading...",
                        style: {
                            font: "20px monospace",
                            fill: "#ffffff",
                        },
                    });
                    loadingText.setOrigin(0.5, 0.5);

                    let percentText = this.make.text({
                        x: width / 2,
                        y: height / 2 - 5,
                        text: "0%",
                        style: {
                            font: "18px monospace",
                            fill: "#ffffff",
                        },
                    });
                    percentText.setOrigin(0.5, 0.5);

                    this.load.on("progress", function(value) {
                        percentText.setText(parseInt(value * 100) + "%");
                        progressBar.clear();
                        progressBar.fillStyle(0xffffff, 1);
                        progressBar.fillRect(380, 330, 300 * value, 30);
                    });
                    /////////////////////////////////////
                    const x = getRandomInt(19);
                    const BASE_IMAGES_URI = "assets/img/game"
                    loadImage(this, "deepspace", `${BASE_IMAGES_URI}/BG ${x}.jpg`)
                    loadImage(this, "Galaxy bar", `${BASE_IMAGES_URI}/Galaxy bar.png`)
                    loadImage(this, "deepspacescore", `${BASE_IMAGES_URI}/Background-4.png`);
                    loadImage(this, "sendscorestbtn", `${BASE_IMAGES_URI}/SendScores.png`);
                    loadSpritesheet(this, "sprExplosion", `${BASE_IMAGES_URI}/sprExplosion.png`, 32, 32)
                    loadSpritesheet(this, "sprRocketexolodePlayer", `${BASE_IMAGES_URI}/Sprite_Explosion.png`, 300, 157)
                    loadSpritesheet(this, "squrebar", `${BASE_IMAGES_URI}/Outline.png`, 80, 60)
                    loadSpritesheet(this, "squrebar2", `${BASE_IMAGES_URI}/Outline2.png`, 108, 81)
                        /////////////////////////////////////////////////////////////////////
                    const GameData = JSON.parse(
                        localStorage.getItem("GameData")
                    );
                    this.sceneGlobales.prepare(GameData)
                    EnemyHandler.prepare()
                        ////////////////////////////////////////////////////////////////////////
                    loadAudio(this, "sndExplode0", `${BASE_IMAGES_URI}/sndExplode0.wav`)
                    loadAudio(this, "sndExplode1", `${BASE_IMAGES_URI}/sndExplode1.wav`)
                    loadAudio(this, "stop", `${BASE_IMAGES_URI}/stop.wav`)
                    loadAudio(this, "rocketexplode", `${BASE_IMAGES_URI}/rocketexplode.wav`)
                    loadAudio(this, "shieldsColliders", `${BASE_IMAGES_URI}/shieldsColliders.wav`)
                    loadAudio(this, "swap", `${BASE_IMAGES_URI}/swap.wav`)
                    loadAudio(this, "swap2", `${BASE_IMAGES_URI}/swap2.wav`)
                    loadAudio(this, "reload shoot", `${BASE_IMAGES_URI}/reload shoot.wav`)
                    firetail.firetailAssets(this, 'fire', 'assets/img/game/muzzleflash3.png');
                    Player.loadAssets(this, this.sceneGlobales.getPlayer().name, 45, 45, this.sceneGlobales.getPlayer().sprite_photo);
                    loadAudio(this, "moveup", `${this.sceneGlobales.getPlayer().soundUp}`);
                    loadAudio(this, "movedown", `${this.sceneGlobales.getPlayer().soundDown}`);
                    loadAudio(this, "moveleft", `${this.sceneGlobales.getPlayer().soundLeft}`);
                    loadAudio(this, "moveright", `${this.sceneGlobales.getPlayer().soundRight}`);
                    this.sceneGlobales.getWeapons().forEach(weapon => {
                        Bar.loadAssets(this, weapon.bar_key, 80, 60, weapon.bar_photo);
                        Shoot.loadAssets(this, weapon.name, weapon.audio_key, weapon.sprite_photo, weapon.sound);
                    });
                    this.sceneGlobales.getShields().forEach(shield => {
                        Bar.loadAssets(this, shield.bar_key, 60, 45, shield.bar_photo);
                        Shield.loadAssets(this, shield.name, 128, 96, shield.audio_key, shield.sprite_photo, shield.sound);
                    });
                    this.sceneGlobales.getRepairekits().forEach(repairekit => {
                        Bar.loadAssets(this, repairekit.bar_key, 60, 45, repairekit.bar_photo);
                        loadAudio(this, `${repairekit.audio_key}`, `${repairekit.sound}`);
                    });
                    EnemyHandler.getEnemies().forEach((enemy, en) => {
                                enemy.class.loadAssets(this, enemy.name, `${BASE_IMAGES_URI}/${enemy.name}.png`, 12, 16);
                                EnemyLaser.loadAssets(this, `${EnemyHandler.getEnemyshoots()[en].name}`, `${BASE_IMAGES_URI}/${`${EnemyHandler.getEnemyshoots()[en].name}`}.png`);
            });
            SelfDestruction.loadAssets(this, `self destruction`, `${BASE_IMAGES_URI}/self destruction.png`, "selfDestructionwav", `${BASE_IMAGES_URI}/selfDestructionwav.wav`);
            FuelBar.loader(this,"health_bar_bg","assets/img/game/HealthBar.png");
            this.load.on(
                "complete",
                function() {
                    progressBar.destroy();
                    progressBox.destroy();
                    loadingText.destroy();
                    percentText.destroy();
                    this.scene.start("SceneMain", { mode: this.mode, player: this.sceneGlobales.getPlayer(), weapons: this.sceneGlobales.getWeapons(), shields: this.sceneGlobales.getShields(), repairekits: this.sceneGlobales.getRepairekits(), enemies: EnemyHandler.getEnemies(), enemyshoots: EnemyHandler.getEnemyshoots() });
                },
                this
            );

            this.load.on(
                "postprocess",
                function() {
                    this.scene.start("SceneMain", { mode: this.mode, player: this.sceneGlobales.getPlayer(), weapons: this.sceneGlobales.getWeapons(), shields: this.sceneGlobales.getShields(), repairekits: this.sceneGlobales.getRepairekits(), enemies: EnemyHandler.getEnemies(), enemyshoots: EnemyHandler.getEnemyshoots() });
                },
                this
            );


        } else {
            this.scene.start("SceneMain", { mode: this.mode, player: this.sceneGlobales.getPlayer(), weapons: this.sceneGlobales.getWeapons(), shields: this.sceneGlobales.getShields(), repairekits: this.sceneGlobales.getRepairekits(), enemies: EnemyHandler.getEnemies(), enemyshoots: EnemyHandler.getEnemyshoots() });
        }
    }

    create() {}

    update() {}
}